import React from 'react'
import { useDispatch } from 'react-redux'
import { setModal } from '../../../../app/store/reducers/AppSlice'
import { LanguageComplianceReport } from '../../widgets/language-compliance-report/LanguageComplianceReport'

interface InfringementsCellProps {
  infringements_count: number
  hash: string
  url: string
  state?: string
}

export const InfringementsCell = ({
  infringements_count,
  hash,
  url,
  state = 'last_check',
}: InfringementsCellProps) => {
  const dispatch = useDispatch()

  return (
    <div className={'flex items-center gap-[6px]'}>
      {infringements_count}
      <span
        className={'cursor-pointer border-b border-dotted text-[13px] leading-[13px] text-focus'}
        onClick={() => {
          dispatch(
            setModal({
              size: 'lg',
              children: <LanguageComplianceReport id={hash} state={state} url={url} />,
            }),
          )
        }}
      >
        Report
      </span>
    </div>
  )
}
